import { useEffect } from 'react';
import { useAppDispatch } from '@/lib/redux/store';
import { useFetchStats } from '@/containers/Accounts/api';
import useUser from './useUser';
import { setIsStatsLoading, setStats } from '@/lib/redux/app.slice';

const useInitializeFetchStats = () => {
  const dispatch = useAppDispatch();
  const { isLoggedIn } = useUser();
  const { isLoading, data } = useFetchStats(isLoggedIn);

  // Update redux
  useEffect(() => {
    if (data && !isLoading) {
      if (data.data) {
        dispatch(setStats(data.data));
      }
    }
    dispatch(setIsStatsLoading(isLoading));
  }, [data, dispatch, isLoading]);
};

export default useInitializeFetchStats;
